<template>
  <div class="text-image-ff">
    <div class="text-image-ff__element">
      <h5 v-if="title" v-html="title"/>
      <p v-if="description" v-html="description"/>
      <router-link
        v-if="!loading"
        :to="link"
        class="glaxi__link">
          {{ textButton }}
      </router-link>
    </div>
    <div class="text-image-ff__element text-image-ff__element--image">
      <picture>
        <source media="(min-width: 700px)" :srcset="image">
        <img :src="imageMobile" :alt="title">
      </picture>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DescriptionArea',
  props: {
    title: {
      type: String,
      required: false
    },
    description: {
      type: String,
      required: false
    },
    image: {
      type: String,
      required: false
    },
    imageMobile: {
      type: String,
      required: false
    },
    textButton: {
      type: String,
      required: false
    },
    link: {
      type: Object,
      required: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss">
  @import "./component.scss";
</style>
